export const jobsConstants = {
  // hms client token
  GET_SHARED_JOB_DETAIL_ACTION_REQUEST: "GET_SHARED_JOB_DETAIL_ACTION_REQUEST",
  GET_SHARED_JOB_DETAIL_ACTION_SUCCESS: "GET_SHARED_JOB_DETAIL_ACTION_SUCCESS",
  GET_SHARED_JOB_DETAIL_ACTION_FAILURE: "GET_SHARED_JOB_DETAIL_ACTION_FAILURE",

  GET_ALL_JOBS_USER_ACTION_REQUEST: "GET_ALL_JOBS_USER_ACTION_REQUEST",
  GET_ALL_JOBS_USER_ACTION_SUCCESS: "GET_ALL_JOBS_USER_ACTION_SUCCESS",
  GET_ALL_JOBS_USER_ACTION_FAILURE: "GET_ALL_JOBS_USER_ACTION_FAILURE",
  // get job details
  GET_JOB_DETAILS_USER_ACTION_REQUEST: "GET_JOB_DETAILS_USER_ACTION_REQUEST",
  GET_JOB_DETAILS_USER_ACTION_SUCCESS: "GET_JOB_DETAILS_USER_ACTION_SUCCESS",
  GET_JOB_DETAILS_USER_ACTION_FAILURE: "GET_JOB_DETAILS_USER_ACTION_FAILURE",

  // all applied candidates
  ALL_APPLIED_CANDIDATES_LIST_REQUEST: "ALL_APPLIED_CANDIDATES_LIST_REQUEST",
  ALL_APPLIED_CANDIDATES_LIST_SUCCESS: "ALL_APPLIED_CANDIDATES_LIST_SUCCESS",
  ALL_APPLIED_CANDIDATES_LIST_FAILURE: "ALL_APPLIED_CANDIDATES_LIST_FAILURE",

  //invite to job
  INVITE_USER_TO_JOB_REQUEST: "INVITE_USER_TO_JOB_REQUEST",
  INVITE_USER_TO_JOB_SUCCESS: "INVITE_USER_TO_JOB_SUCCESS",
  INVITE_USER_TO_JOB_FAILURE: "INVITE_USER_TO_JOB_FAILURE",

  // get job details
  GET_INVITED_JOBS_USER_ACTION_REQUEST: "GET_INVITED_JOBS_USER_ACTION_REQUEST",
  GET_INVITED_JOBS_USER_ACTION_SUCCESS: "GET_INVITED_JOBS_USER_ACTION_SUCCESS",
  GET_INVITED_JOBS_USER_ACTION_FAILURE: "GET_INVITED_JOBS_USER_ACTION_FAILURE",


   // get job details
   ASSIGN_EVENT_TO_JOB_ACTION_REQUEST: "ASSIGN_EVENT_TO_JOB_ACTION_REQUEST",
   ASSIGN_EVENT_TO_JOB_ACTION_SUCCESS: "ASSIGN_EVENT_TO_JOB_ACTION_SUCCESS",
   ASSIGN_EVENT_TO_JOB_ACTION_FAILURE: "ASSIGN_EVENT_TO_JOB_ACTION_FAILURE",

   SEND_INTERVIEW_INVITATION_TO_CANDIDATE_ACTION_REQUEST: "SEND_INTERVIEW_INVITATION_TO_CANDIDATE_ACTION_REQUEST",
   SEND_INTERVIEW_INVITATION_TO_CANDIDATE_ACTION_SUCCESS: "SEND_INTERVIEW_INVITATION_TO_CANDIDATE_ACTION_SUCCESS",
   SEND_INTERVIEW_INVITATION_TO_CANDIDATE_ACTION_FAILURE: "SEND_INTERVIEW_INVITATION_TO_CANDIDATE_ACTION_FAILURE",



};
